import { render, staticRenderFns } from "./ProductsCollection.vue?vue&type=template&id=0acfbf1f&lang=pug&"
import script from "./ProductsCollection.vue?vue&type=script&lang=js&"
export * from "./ProductsCollection.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports